/**
 * 日志服务钩子
 * 提供便捷访问日志服务的方法
 *
 * 核心功能：
 * 1. 获取日志上下文
 * 2. 提供类型安全的日志服务访问
 * 3. 确保在Provider内部使用
 */
import { useContext } from 'react';
import { LoggingContext } from '../contexts/LoggingContext.js';
/**
 * 使用日志服务钩子
 * 便于在组件中使用日志服务
 *
 * @returns 日志服务实例
 * @throws 如果在LoggingProvider外部使用则抛出错误
 *
 * @example
 * ```tsx
 * const logger = useLogger();
 *
 * // 使用日志方法
 * logger.error('出现错误', { error });
 * ```
 */
export function useLogger() {
    const logger = useContext(LoggingContext);
    if (logger === null) {
        throw new Error('useLogger must be used within a LoggingProvider');
    }
    return logger;
}
/**
 * 默认导出钩子函数
 * 便于导入使用
 */
export default useLogger;
//# sourceMappingURL=useLogger.js.map